import React, { useState } from 'react';
import {VscVerifiedFilled} from "react-icons/vsc";

interface PartnerCardProps {
  imageUrl: string;
  logoUrl: string;
  name: string;
  description: string;
  verified?: boolean;
  category: string;
}

const PartnerCard: React.FC<PartnerCardProps> = ({ imageUrl, logoUrl, name, description, verified = false, category }) => {
  const [isImageError, setIsImageError] = useState(false);
  const [isLogoError, setIsLogoError] = useState(false);

  return (
    <div className="group relative w-full max-w-xs mx-auto bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
      {/* Main image */}
      <div className="relative w-full aspect-[4/3]">
        {!isImageError ? (
          <img
            src={imageUrl}
            alt={name}
            className="w-full h-full object-cover"
            onError={() => setIsImageError(true)}
          />
        ) : (
          <div className="w-full h-full bg-gray-50 flex justify-center items-center">
            <span className="text-gray-400">이미지 없음</span>
          </div>
        )}
        
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      {/* Content container */}
      <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center gap-3">
        {/* Logo */}
        {!isLogoError ? (
          <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden border-2 border-white shadow-lg">
            <img
              src={logoUrl}
              alt="Logo"
              className="w-full h-full object-cover"
              onError={() => setIsLogoError(true)}
            />
          </div>
        ) : (
          <div className="flex-shrink-0 w-12 h-12 bg-blue-500 rounded-lg border-2 border-white shadow-lg flex items-center justify-center">
            <span className="text-white text-lg font-bold">{name.charAt(0)}</span>
          </div>
        )}

        {/* Text content */}
        <div className="flex-grow">
          <div className="flex items-center gap-2">
            <h3 className="text-white font-semibold Pretendard-Bold truncate">
              {name}
            </h3>
            {verified && (
              <VscVerifiedFilled className="text-blue-400 flex-shrink-0" size={16} />
            )}
          </div>
          <p className="text-xs text-gray-300 Pretendard-Regular mt-0.5">
            {category}
          </p>
          <p className="text-sm text-gray-200 Pretendard-Regular whitespace-nowrap overflow-hidden mt-0.5">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerCard;
